<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      size="480px"
      :modal="false"
      :before-close="handleClose"
      @close="handleClose"
    >
      <div class="article-detail" v-loading="loading">
        <div class="article-top clear" style="display: flex">
          <div style="padding: 0 10px;font-size: 14px;flex: 1" class="left">
            文章详情
          </div>
          <div @click="close" class="tRight">×</div>
          <!-- <el-divider></el-divider> -->
        </div>
        <div>
          <h3 class="title ml15 left">
            {{ item.title }}
          </h3>
          <div class="tips ml15">
            <div style="flex: 1" class="left">
              <span>标签：</span>
              <template
                v-if="item.labelNameList != null && item.labelNameList != ''"
              >
                <span
                  @click.stop="deleteTag(tag)"
                  class=" ml5 label cursor"
                  v-for="tag in item.labelNameList.split('|')"
                  :key="tag"
                  >{{ tag }}
                  <!-- <span @click.stop="deleteTag(tag)" class="iconfont delete"
                    >&#xe6a5;</span
                  > -->
                  <img
                    src="../../assets/image/document/whitedelete.png"
                    width="13"
                    height="13"
                  />
                </span>
              </template>
              <span @click.stop="add" class="iconfont ml5 add">&#xe74a;</span>
            </div>
            <div>
              <span>{{ item.platformName }}</span>
              <span class="mr5">在</span>
              <span>{{ item.issueTime }}</span>
              <span>收藏</span>
            </div>
          </div>
          <div
            id="article-content"
            class="article-content ml15"
            v-html="item.articleContent"
          ></div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "popoutDetail",
  props: ["guid", "isShow", "type", "labelNameList"],
  data() {
    return {
      item: [],
      popoverVisible: false,
      // guid: "6FCBC6F3-0683-EA11-8DA3-20040FF9D71D",
      loading: false,
      drawer: this.isShow
    };
  },
  computed: {
    ...mapState("material", ["tags"]),
    insertHtml: {
      get() {
        return this.$store.state.editorControl.insertHtml;
      },
      set(val) {
        this.$store.state.editorControl.insertHtml = val;
      }
    },
    wycContent: {
      get() {
        return this.$store.state.wycContent.wycContent;
      },
      set(val) {
        this.$store.state.wycContent.wycContent = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      }
    },
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "article-content", 30);
      }
    }
  },
  methods: {
    ...mapActions("api", ["AActicledetail"]),
    ...mapActions("material", [
      "AFavoriteResourcesDetail",
      "AFavoriteParagraphDetail",
      "ALabelBind"
    ]),
    ...mapMutations("material", [
      "AsetDetailPop",
      "ASetDialogTagVisible",
      "AUpdateArticleLabelNameList"
    ]),
    back() {
      // this.setActicledetail("");
      this.$router.back(-1);
    },
    close() {
      this.drawer = false;
    },
    full() {
      if (this.wycShow) {
        if (this.wycContent === this.item.articleContent) {
          this.$message({
            message: "已使用过相同文章精华",
            type: "warning"
          });
          return;
        }
      } else {
        if (this.insertHtml === this.item.articleContent) {
          this.$message({
            message: "已使用过相同文章精华",
            type: "warning"
          });
          return;
        }
      }
      this.wycShow
        ? (this.wycContent = this.item.articleContent)
        : (this.insertHtml = this.item.articleContent);
      this.$message({
        message: "文章全文引入成功",
        showClose: true,
        type: "success"
      });
    },
    introduce() {
      this.insertHtml = this.item.articleContent;
    },
    getIcon(resourcePlatformName) {
      if (resourcePlatformName === "今日头条") {
        return require("../../assets/image/icon/tt.png");
      } else if (resourcePlatformName === "知乎") {
        return require("../../assets/image/icon/zh.png");
      } else if (resourcePlatformName === "微信") {
        return require("../../assets/image/icon/wx.png");
      } else if (resourcePlatformName === "全网采集") {
        return require("../../assets/image/icon/qwcj.png");
      } else if (resourcePlatformName === "网易") {
        return require("../../assets/image/icon/wangyi.png");
      } else if (resourcePlatformName === "新浪网") {
        return require("../../assets/image/icon/sina.png");
      } else if (resourcePlatformName === "简书") {
        return require("../../assets/image/icon/jianshu.png");
      } else if (resourcePlatformName === "凤凰网") {
        return require("../../assets/image/icon/ifeng.png");
      } else if (resourcePlatformName === "搜狐") {
        return require("../../assets/image/icon/sohu.png");
      }
    },
    async getDetail() {
      this.loading = true;
      var result = await this.AFavoriteResourcesDetail({
        favoriteResourceId: this.guid
      });
      if (result.errorCode === 0) {
        this.item = result.data;
        this.item.articleContent = this.filterDetail(this.item.articleContent.replace(/<img .*?>/g,''));
      }

      this.$nextTick(() => {
        try {
          let imgDomList = document
            .getElementsByClassName("article-content")[0]
            .getElementsByTagName("img");
          for (let img of imgDomList) {
            img.src = img.dataset["src"];
          }
        } catch (e) {
          //console.log(e);
        }
      });
      this.loading = false;
    },
    async getParagraphDetail() {
      this.loading = true;
      var result = await this.AFavoriteParagraphDetail({
        favoriteParagraphId: this.guid
      });
      if (result.errorCode === 0 && result.data != null) {
        this.item = result.data;
        this.item.articleContent = this.filterDetail(this.item.articleContent);
      }

      this.$nextTick(() => {
        try {
          let imgDomList = document
            .getElementsByClassName("article-content")[0]
            .getElementsByTagName("img");
          for (let img of imgDomList) {
            img.src = img.dataset["src"];
          }
        } catch (e) {
          //console.log(e);
        }
      });
      this.loading = false;
    },
    filterDetail(detail) {
      detail = detail.replace(
        '<div class="._5ce-wx-style" style="width:740px">',
        '<div class="._5ce-wx-style" style="width:100%">'
      );
      detail = detail.replace(new RegExp("width: 660px;", "gi"), "");
      detail = detail.replace(
        new RegExp("<img ", "gi"),
        '<img style="width:100%"'
      );
      return detail;
    },
    handleClose() {
      this.AsetDetailPop({
        isShowDetail: false,
        id: 0,
        detailType: ""
      });
    },
    add() {
      this.ASetDialogTagVisible({
        dialogTagVisible: true,
        detailLableNameList: this.item.labelNameList,
        detailTag: this.item.labelNameList,
        detailId: this.guid
      });
      //this.ASetDialogTagVisible(true);
      //alert("添加标签");
    },
    async deleteTag(tag) {
      // var labelNameList = this.item.labelNameList;
      // var labelResult = this.item.labelNameList.split("|");
      var result = this.tags.filter(m => {
        return this.item.labelNameList.split("|").includes(m.labelName);
      });
      var tagsResult = result.filter(m => {
        return m.labelName != tag;
      });

      var labelIdList = tagsResult.map(m => m.labelId);

      var bindResult = await this.ALabelBind({
        labelIdList: labelIdList.join("|"),
        dataID: this.guid,
        dataType: this.type == "article" ? "resource" : this.type
      });
      if (bindResult.errorCode === 0) {
        this.item.labelNameList = tagsResult.map(m => m.labelName).join("|");
        this.AUpdateArticleLabelNameList({
          favoriteResourceId: this.guid,
          labelNameList: this.item.labelNameList
        });
      }
    },
    setLabelNameList(labelNameList) {
      this.item.labelNameList = labelNameList;
    }
  },
  mounted() {
    let getid = setInterval(() => {
      let getBox = document.getElementById("article-content");
      if (getBox) {
        clearInterval(getid);
        // console.log(this.contentHeight);
        this.getHotLineHeight(this.contentHeight, "article-content", 30);
      }
    }, 500);
    if (this.type == "article") {
      this.getDetail();
    }
    if (this.type == "paragraph") {
      this.getParagraphDetail();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
h3 {
  font-size: 20px;
}
// /deep/.el-drawer {
//   // top: 60px;
// }
//头部
.article-top {
  height: 50px;
  margin-bottom: 15px;
  box-sizing: border-box;
  padding-top: 15px;
  border-bottom: 1px solid #d3d7de;
  width: 480px;
}
.tRight {
  float: right;
  font-size: 25px;
  cursor: pointer;
  margin-right: 10px;
  color: #b5a8a8;
  margin-top: -10px;
}
.article-top button {
  display: inline-block;
}
.article-top button.back {
  color: #ea8183;
  padding: 7px 10px;
  border-color: #ea8183;
}
.article-top button.back:hover {
  background-color: @theme-background-color;
}
//标题
.article-detail {
  background-color: @theme-background-color;
  width: 460px;
}
//文章作者，时间等
//tips
.article-detail .tips {
  margin-top: 15px;
  display: flex;
  color: #999;
  align-items: center;
  .top {
    /*padding-left: 15px;*/
    background: url("../../assets/image/icon/top.png") no-repeat 0;
  }
}
.icons {
  display: inline-block;
  height: 15px;
  width: 15px;
  vertical-align: text-bottom;
}
// .article-detail .tips span {
//   color: #666666;
//   margin-right: 10px;
//   font-size: @font-size12;
// }
.article-detail .tips .read {
  color: #f48b1e;
}
//文章内容
.article-detail .article-content {
  margin-top: 15px;
  font-size: 14px;
  /*line-height: 1.5em;*/
  padding-right: 15px;
  height: 500px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
  line-height: 25px;
  text-align: left;
}
.article-detail .tips .tag {
  background-color: #f39117;
  padding: 1px 8px;
  border-radius: 10px;
  color: white;
  font-size: 12px;
}
.article-detail .tag .delete {
  margin-left: 3px;
  cursor: pointer;
  font-size: 14px;
  color: white;
}
.article-detail .tips .add {
  color: #f39117;
  cursor: pointer;
}
</style>
